import type { ToastPosition } from 'react-toastify';
import { toast } from 'react-toastify';
import Icon from '@/components/Icon/Icon';

/**
 * A method to open the toast.
 *
 * @param message - The message to display on the toast
 * @param icon - The icon to display on the toast,
 * @param type - The toast type.
 */
export const showToastrMessage = (
  message: string,
  type: string,
  position: ToastPosition = 'top-right',
  toastId?: string
) => {
  let TOAST_TYPE;
  let icon;
  let toastClassName: string | undefined;

  if (type === 'success') {
    TOAST_TYPE = toast.TYPE.SUCCESS;
    icon = 'success';
  } else if (type === 'store-success') {
    TOAST_TYPE = toast.TYPE.SUCCESS;
    icon = 'success';
    toastClassName = 'Toastify__toast--store-flow-success';
  } else if (type === 'warning') {
    TOAST_TYPE = toast.TYPE.WARNING;
    icon = 'failure';
  } else if (type === 'failure' || type === 'error') {
    TOAST_TYPE = toast.TYPE.ERROR;
    icon = 'failure';
  } else if (type === 'info') {
    TOAST_TYPE = toast.TYPE.INFO;
    icon = 'success';
  }

  toast(
    <div>
      <div className="toast-container">
        <Icon className="toast-icon" source={`/src/assets/svg/${icon}.svg`} />
        <div className="toast-message">{message}</div>
      </div>
    </div>,
    { position, autoClose: 2000, type: TOAST_TYPE, className: toastClassName, toastId }
  );
};

/**
 * Clear toast messages
 */
export const clearToasts = () => {
  toast.clearWaitingQueue();
  toast.dismiss();
};
